module.exports = function getResource(label, vars = []) {
    let resources = {
        straighteningLabel: 'Straightening',
        beingLabel: 'being'
    };

    return resources[label];
};
